import * as yup from 'yup';
import { VALIDAR } from './mensajesGenericos';

export const nuevaContrasenaSchema = yup.object({
    contra_actual: yup.string().required("La contraseña actual es obligatoria"),
    
    contra_nueva: VALIDAR.CONTRASENA,
    
    contra_confirmar: yup.string()
        .oneOf([yup.ref('contra_nueva')], "Las contraseñas no coinciden")
        .required("Debe confirmar la nueva contraseña")
});